import { withRouter, generatePath } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import H2 from 'UIComponents/elements/headings/H2';
import { parseLocation } from 'automation-ui-routing/utils';
import { mapActionTypeToRoute } from 'automation-ui-canvas/utils/data-passing/mapActionTypeToRoute';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { PLATFORM_ACTION_EDIT } from 'automation-ui-canvas/constants/AbsolutePaths';
import { getScreenForFlowType } from 'automation-ui-canvas/utils/getScreenForFlowType';
import { buildSearchStringWithCurrentSourceFields } from 'automation-ui-canvas/utils/routingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataSourceEditPanelHeader = ({
  history,
  location,
  match,
  flowType
}) => {
  const {
    actionId,
    flowId
  } = match.params;
  const screen = getScreenForFlowType(flowType);
  return /*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: () => {
        const {
          edgeId,
          actionType
        } = parseLocation(location);
        const search = buildSearchStringWithCurrentSourceFields({
          location,
          queryParams: {
            edgeId
          }
        });
        const configRoute = mapActionTypeToRoute({
          actionType
        });
        history.replace({
          pathname: generatePath(PLATFORM_ACTION_EDIT, {
            flowId,
            screen,
            actionId,
            configRoute
          }),
          search
        });
      }
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.dataSourceEditCanvas.header"
      })
    })]
  });
};
export const WEBPACK_3_FORCE_MODULE_IMPORT = 1;
export default withRouter(DataSourceEditPanelHeader);